var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.348,
    height: 16,
    viewBox: "0 0 24.348 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    fill: "none",
    d: "M1.391-23h21.566a1.391 1.391 0 0 1 1.391 1.391v13.218A1.391 1.391 0 0 1 22.957-7H1.391A1.391 1.391 0 0 1 0-8.391v-13.218A1.391 1.391 0 0 1 1.391-23z",
    clipRule: "evenodd",
    transform: "translate(0 23)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M10.032-3.767v-.793a.471.471 0 0 0-.132-.364.471.471 0 0 0-.362-.139.489.489 0 0 0-.444.225.464.464 0 0 0-.418-.225.418.418 0 0 0-.37.188v-.156h-.278v1.264h.278v-.7a.3.3 0 0 1 .075-.233.3.3 0 0 1 .234-.1c.182 0 .275.119.275.333v.7h.278v-.7a.3.3 0 0 1 .076-.24.3.3 0 0 1 .233-.1c.188 0 .278.119.278.333v.7zm4.108-1.264h-.452v-.383h-.278v.383h-.25v.251h.257v.58c0 .294.114.468.439.468a.645.645 0 0 0 .344-.1l-.079-.235a.508.508 0 0 1-.243.071c-.132 0-.182-.085-.182-.212v-.572h.45zm2.346-.032a.373.373 0 0 0-.333.185v-.153h-.272v1.264h.275v-.709c0-.209.09-.325.264-.325a.448.448 0 0 1 .172.032l.085-.264a.589.589 0 0 0-.2-.034zm-3.546.132a.945.945 0 0 0-.516-.132c-.32 0-.529.153-.529.4 0 .206.153.333.436.373l.132.019c.151.021.222.061.222.132 0 .1-.1.153-.288.153a.673.673 0 0 1-.42-.132l-.132.214a.912.912 0 0 0 .547.164c.365 0 .577-.172.577-.413s-.167-.339-.442-.378l-.127-.014c-.119-.016-.214-.04-.214-.124s.09-.148.241-.148a.815.815 0 0 1 .4.108zm7.367-.132a.373.373 0 0 0-.333.185v-.153H19.7v1.264h.275v-.709c0-.209.09-.325.264-.325a.448.448 0 0 1 .172.032l.085-.264a.588.588 0 0 0-.2-.034zm-3.544.663a.639.639 0 0 0 .191.48.639.639 0 0 0 .483.182.661.661 0 0 0 .455-.151l-.132-.222a.555.555 0 0 1-.33.111.406.406 0 0 1-.373-.4.406.406 0 0 1 .373-.4.555.555 0 0 1 .331.114l.132-.222a.661.661 0 0 0-.455-.151.639.639 0 0 0-.483.182.639.639 0 0 0-.191.48zm2.576 0v-.629h-.275v.153a.48.48 0 0 0-.4-.185.661.661 0 0 0-.661.661.661.661 0 0 0 .661.661.48.48 0 0 0 .4-.185v.153h.275zm-1.023 0a.382.382 0 0 1 .4-.359.382.382 0 0 1 .368.388A.382.382 0 0 1 18.7-4a.38.38 0 0 1-.28-.118.38.38 0 0 1-.1-.286zM15-5.063a.661.661 0 0 0-.652.67.661.661 0 0 0 .67.652.768.768 0 0 0 .525-.172l-.132-.2a.6.6 0 0 1-.368.132.35.35 0 0 1-.378-.309h.935v-.11a.6.6 0 0 0-.6-.66zm0 .246a.313.313 0 0 1 .224.087.313.313 0 0 1 .1.22h-.661a.325.325 0 0 1 .336-.307zm6.891.418v-1.14h-.264v.661a.48.48 0 0 0-.4-.185.661.661 0 0 0-.661.661.661.661 0 0 0 .661.661.48.48 0 0 0 .4-.185v.153h.264zm.459.448a.132.132 0 0 1 .05.009.132.132 0 0 1 .041.026.132.132 0 0 1 .028.04.123.123 0 0 1 0 .1.132.132 0 0 1-.028.04.132.132 0 0 1-.041.026.124.124 0 0 1-.05.011.132.132 0 0 1-.119-.077.124.124 0 0 1 0-.1.132.132 0 0 1 .028-.04.132.132 0 0 1 .041-.026.132.132 0 0 1 .054-.009zm0 .223a.094.094 0 0 0 .038-.008.1.1 0 0 0 .03-.021.1.1 0 0 0 0-.132.1.1 0 0 0-.03-.021.1.1 0 0 0-.038-.008.1.1 0 0 0-.038.008.1.1 0 0 0-.032.021.1.1 0 0 0 0 .132.1.1 0 0 0 .032.021.1.1 0 0 0 .042.008zm.008-.157a.053.053 0 0 1 .034.011.033.033 0 0 1 .012.028.032.032 0 0 1-.009.024.046.046 0 0 1-.028.012l.038.044h-.03l-.036-.044h-.012v.044H22.3v-.116zm-.029.022v.032h.029a.028.028 0 0 0 .016 0 .013.013 0 0 0 0-.012.013.013 0 0 0 0-.012.028.028 0 0 0-.016 0zM20.87-4.4a.382.382 0 0 1 .4-.359.382.382 0 0 1 .368.388.382.382 0 0 1-.38.376.38.38 0 0 1-.28-.118.38.38 0 0 1-.1-.286zm-9.287 0v-.632h-.275v.153a.48.48 0 0 0-.4-.185.661.661 0 0 0-.661.661.661.661 0 0 0 .661.661.48.48 0 0 0 .4-.185v.153h.275zm-1.023 0a.382.382 0 0 1 .4-.359.382.382 0 0 1 .368.388.382.382 0 0 1-.38.376.379.379 0 0 1-.282-.117.38.38 0 0 1-.1-.287z",
    className: "cls-2",
    transform: "translate(-8.028 5.539)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M14.958-18.657h4.165v7.486h-4.165z",
    className: "cls-2",
    transform: "translate(-14.958 18.657)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M12.764-15.358a4.752 4.752 0 0 1 1.819-3.742 4.76 4.76 0 0 0-6.439.513 4.76 4.76 0 0 0 0 6.459 4.76 4.76 0 0 0 6.439.513 4.752 4.752 0 0 1-1.818-3.742z",
    className: "cls-2",
    transform: "translate(-6.881 20.119)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M25.655-15.359a4.76 4.76 0 0 1-2.68 4.282 4.76 4.76 0 0 1-5.022-.539 4.76 4.76 0 0 0 1.819-3.743 4.76 4.76 0 0 0-1.82-3.741 4.76 4.76 0 0 1 5.022-.539 4.76 4.76 0 0 1 2.68 4.282z",
    className: "cls-2",
    transform: "translate(-17.952 20.12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M28.4-8.612v-.572h.108V-9.3h-.273v.118h.117v.572zm.53 0V-9.3h-.083l-.1.493-.1-.493h-.067v.691h.06v-.521l.09.449h.062l.09-.449v.523z",
    className: "cls-2",
    transform: "translate(-28.234 9.303)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none}.cls-12{fill:#f79d1b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-Payment-Mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    fill: "#f9f9f9",
    d: "M-5-28h31.3v22.957H-5z",
    transform: "translate(1.522 24.522)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    clipPath: "url(#clip-path-2)",
    transform: "translate(5.585 12.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fill: "#221e20",
    d: "M3.028-10.539h21.4v8.795h-21.4z",
    transform: "translate(-6.506 7.061)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    clipPath: "url(#clip-path-3)",
    transform: "translate(10.406 3.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    fill: "#ff5e00",
    d: "M9.958-23.657H21.08v14.443H9.958z",
    transform: "translate(-13.437 20.178)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    clipPath: "url(#clip-path-4)",
    transform: "translate(4.787 2.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    fill: "#ea001b",
    d: "M1.881-25.119h14.658v16.477H1.881z",
    transform: "translate(-5.359 21.641)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    clipPath: "url(#clip-path-5)",
    transform: "translate(12.488 2.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M12.952-25.12h14.659v16.478H12.952z",
    className: "cls-12",
    transform: "translate(-16.43 21.642)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    clipPath: "url(#clip-path-6)",
    transform: "translate(19.641 9.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M23.234-14.3h7.652v7.65h-7.652z",
    className: "cls-12",
    transform: "translate(-26.712 10.824)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentMastercard);
export default __webpack_public_path__ + "static/media/logo-payment-mastercard.da24bd1b.svg";
export { ForwardRef as ReactComponent };